import React from 'react';
import { Bundle } from '@ali/visualengine';
import { createEventSetters } from '@/common/manager/event';
import { ButtonPosition } from '@/type/button-position';
import { getMixedSetterSnippet } from '@/common/manager/setter-snippet';
import { createButtonListSetters } from '@/common/manager/button';

// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype
export default Bundle.createPrototype({
  title: '导航栏',
  componentName: 'CnNavBar',
  category: '布局',
  snippets: [
    {
      screenshot:
        'https://img.alicdn.com/imgextra/i2/O1CN01Gcm7hq1f96TB5Y829_!!6000000003963-0-tps-720-90.jpg',
      label: 'CnNavBar',
      schema: {
        componentName: 'CnNavBar',
        props: {},
      },
    },
  ],
  isContainer: false,
  canHovering: true,
  canSelecting: true,
  canDragging: true,
  enableCopy: true,
  configure: [
    {
      name: 'isCnNavBar',
      title: 'isCnNavBar',
      initialValue: true,
      display: 'none',
    },
    {
      name: '_context',
      title: '上下文',
      initialValue: {
        type: 'JSExpression',
        value: 'this',
      },
      display: 'none',
    },
    {
      name: 'title',
      title: '导航栏标题',
      display: 'inline',
      setter: 'CnI18nSetter',
    },
    {
      name: 'componentStyle',
      display: 'accordion',
      title: '导航栏样式',
      collapsed: true,
      extraProps: {
        defaultCollapsed: true,
      },
      setter: {
        componentName: 'ObjectSetter',
        props: {
          config: {
            items: [
              {
                name: 'enableSafeArea',
                title: '开启安全区',
                setter: 'BoolSetter',
              },
              {
                name: 'backArrow',
                title: '左侧返回按钮',
                defaultValue: true,
                setter: getMixedSetterSnippet({
                  setters: [
                    {
                      componentName: 'BoolSetter',
                      title: '布尔（true/false）',
                    },
                  ],
                }),
              },
            ],
          },
        },
      },
    },
    {
      name: 'right',
      title: '右侧按钮栏',
      display: 'accordion',
      // collapsed:false,
      // initialValue: [],
      // supportVariable: true,
      setter: createButtonListSetters({
        position: ButtonPosition.navBarRightButton,
      }),
    },
    ...createEventSetters({
      position: ButtonPosition.navBarEvent,
      initialValue: {
        // optType: 'setFormStepCurrent'
      },
      title: '配置导航栏的回调',
    }),
  ],
});
